import { css, html, LitElement } from './-global.min.js'

class HHGlobalNotification extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener('wishlistProductToggled', this.onProductToggled.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('wishlistProductToggled', this.onProductToggled.bind(this))
  }

  firstUpdated() {
    this.defaultMessage = this.message.textContent
  }

  onProductToggled(event) {
    this.message = event?.detail?.message ?? ''
  }

  get message() {
    const slot = this.shadowRoot.querySelector('slot[name="message"]')
    return slot?.assignedNodes()?.[0] ?? ''
  }

  set message(value) {
    if (!this.message) return
    this.message.innerHTML = value
  }

  render() {
    return html`
      <h2 class="heading">
        <slot name="icon"></slot>
        <slot name="message"></slot>
      </h2>
      <slot name="actions"></slot>
    `
  }

  static styles = css`
    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    :host {
      display: block;
    }

    .heading {
      font: var(--hh-body-bold-lg-font);
      letter-spacing: var(--hh-body-bold-letter-spacing);
      max-width: 90%;
      align-items: center;
      display: flex;
      flex-grow: 1;
      margin: var(--hh-spacing-sm) 0;
      align-items: flex-start;
    }
  `
}

if (!customElements.get('hh-global-notification')) {
  customElements.define('hh-global-notification', HHGlobalNotification);
}